/**
 * MediaDownloadButton React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';

// Material-UI
import {withStyles} from '@material-ui/core/styles';
import SaveIcon from "@material-ui/icons/SaveAlt";
import Button from "@material-ui/core/Button";


function MediaDownloadButton(props) {

    const {classes, url} = props;
    const filename = url && url.replace(/^.*[\\/]/, '');
    const style = filename && filename.length > 25 ? {fontSize: "10px"} : {};

    return <Button
        variant="extendedFab"
        aria-label="download"
        className={classes.button}
        style={style}
        href={url}
        disabled={!url}
        download
    >
        <SaveIcon className={classes.extendedIcon}/>&nbsp;{filename}
    </Button>;
}

const styles = theme => ({
    button: {
        maxWidth: "calc(100% - 10px)",
        overflow: "hidden",
        marginBottom: 18,
        marginTop: 12,
        marginLeft: 12,
        marginRight: 12
    }
});

export default withStyles(styles)(MediaDownloadButton);
